// import styled from "styled-components";
// import React, { FC, useEffect } from "react";
// import { Box, BoxProps } from "../Box";

// const StyledOverlay = styled(Box)`
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   width: 100%;
//   height: 100%;
//   background-color: "yellow";
//   z-index: 20;
// `;

// const BodyLock = () => {
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "visible";
//     };
//   }, []);

//   return null;
// };

// export const Overlay: FC<BoxProps> = (props) => {
//   return (
//     <>
//       <BodyLock />
//       <StyledOverlay role="presentation" {...props} />
//     </>
//   );
// };

// export default Overlay;

import styled from "styled-components";
import { OverlayProps } from "./types";

const Overlay = styled.div.attrs({ role: "presentation" })<OverlayProps>`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* transition: opacity 0.4s; */
  opacity: ${({ show }) => (show ? 0.6 : 0)};
  z-index: ${({ zIndex }) => zIndex};
  pointer-events: ${({ show }) => (show ? "initial" : "none")};
`;

Overlay.defaultProps = {
  show: false,
  zIndex: 10,
};

export default Overlay;
